import { mapTravelDate } from "./WizardStateMapper";
import { IntentMediaPropsPackages } from "src/components/utility/Ads/IntentMedia/mappers/typings";
import { PackageWizardState } from "stores/wizard/state";
import { TravelersMetadata } from "components/shared/TravelersField/typings";
import { travelersMetadata } from "components/shared/TravelersField/utils";

export function mapPackageWizardState(state: PackageWizardState): IntentMediaPropsPackages {
  const subLobs = Array.from(state.subLOBState || "fh");
  const travelers = subLobs.includes("h") ? state.travelers.hotelPackage : state.travelers.nonHotel;
  const mappedTravelersMetaData: TravelersMetadata = travelersMetadata(travelers);

  return {
    page_id: "homepage.packages",
    trigger_exit_unit: "Y",

    // shared stuff
    travel_date_start: mapTravelDate(state.date.start),
    travel_date_end: mapTravelDate(state.date.end),
    travelers:
      mappedTravelersMetaData.numOfAdults +
      mappedTravelersMetaData.numOfChildren +
      mappedTravelersMetaData.numOfInfants,
    adults: mappedTravelersMetaData.numOfAdults,
    children: mappedTravelersMetaData.numOfChildren + mappedTravelersMetaData.numOfInfants,

    // hotel stuff
    hotel_market_id: state.location.destination.metaData.regionId,
    destination_city: state.location.destination.metaData.shortName,
    destination_country: state.location.destination.metaData.countryCode,
    rooms: state.travelers.hotelPackage.rooms.length,

    // flight stuff
    trip_type: "ROUNDTRIP",
    origin_airport: state.location.origin.metaData.ttla,
    origin_country: state.location.origin.metaData.countryCode,
    destination_airport: state.location.destination.metaData.ttla,
  };
}
